import {Input, RenderWYSIWYG} from 'Components/Form';
import Auth from 'Components/Layouts/Auth';
import CmsElement from 'Components/Utilities/CmsElement';
import React from 'react';

import {Loading} from 'Components/Partials';
import { asset } from 'Services/BaseHelpers';
import { getRecordValue } from 'Services/CmsHelpers';

export default class Travel extends React.Component {

    header = () => (
        <div className="h-banner bg-banner-travel bg-no-repeat bg-cover bg-right relative">
            <div className="absolute h-full w-full flex">
                <span className="m-auto text-app-green-banner text-4xl font-gilroy">Travel information</span>
            </div>
            <img alt="" src={asset('/images/pages/travel/travel-banner.svg')}
                 className="max-h-banner hidden md:block h-full px-2 md:px-4 lg:px-6 py-5 lg:mt-0"
            />
        </div>
    );

    /**
     * @method render
     * @return {*}
     */
    render() {

        return (
            <Auth customHeader={this.header()} containerWidth="" containerPadding={"0"} contentClass="-mt-1">
                <div className={"bg-app-blue text-center text-xl w-full p-5 text-white font-gilroy  right-0 left-0 mb-10"}>
                    Date: Wednesday 25th October 2023 at 3pm
                </div>

                {this.renderCarInfo()}
                {this.renderPlaneInfo()}
                {this.renderFootInfo()}

                <div className="p-4 text-center">
                    <div className="mx-auto">
                        <div className="text-center font-gilroy">
                            If your question isn’t answered in the above please contact us
                            at <a className="text-app-red" href="mailto:info@speedolaunch.com">info@speedolaunch.com</a>
                        </div>
                    </div>
                </div>
            </Auth>
        );
    }

    renderCarInfo(){
        return (
            <div className={"flex flex-col lg:flex-row mt-10 p-20 gap-10"}>
                    <div className={"w-full lg:w-1/2 flex flex-col p-15 h-full self-end"}>
                        <div className={"text-app-red font-gilroy mx-5 text-3xl font-medium"}>
                            Car
                        </div>
                        <div className={"font-gilroy mb-5 mx-5 font-bold"}>
                            For satellite navigation reference, the postcode for Pentland is N3 2QT.
                        </div>
                        <div className={"text-app-red font-gilroy mx-5 text-2xl"}>
                            From the north (M1).
                        </div>
                        <div className={"font-gilroy mx-5 h-full"}>
                            Leave the M1 at Junction 2 and take the Great North Way (A1 eastbound). After six minutes turn left onto Hendon Lane.
                            Continue onto Ballards Lane then, after half a mile, turn right onto Long Lane. Drive for a further two minutes then
                            turn right again onto Squires Lane. After 200 yards the entrance to Lakeside will be on your right.
                        </div>
                    </div>

                    <div className={"w-full lg:w-1/2 flex flex-col p-15"}>
                        <img className={"w-48 m-5"} src={asset('images/car.png')} />
                        <div className={"text-app-red font-gilroy text-xl mx-5"}>
                            From central London and the south (A406)
                        </div>
                        <div className={"font-gilroy mx-5"}>
                            Travelling on the North Circular Road (A406) towards Finchley, take the A1000 exit towards North
                            and East Finchley/Barnet.
                            At the top of the ramp, continue straight on at the traffic lights onto Squires Lane.
                            Continue along Squires Lane for half a mile before turning right into Lakeside.
                        </div>
                    </div>
                </div>

        );
    }
    renderPlaneInfo(){
        return (
            <div className={"flex flex-col lg:flex-row"}>
                <div className={"w-full lg:w-1/2 flex -ml-15 mr-15 flex-row p-20 bg-app-gray-travel-dark relative"}>
                        <div className={"flex flex-col"}>
                            <div className={"font-gilroy mb-5 mx-5 text-white flex flex-row pt-10 "}>
                                <img className={"w-20 ml-5"} src={asset('images/plane.png')} />
                                <div className={"self-end text-white text-5xl font-gilroy"}>
                                    Airport
                                </div>
                            </div>
                            <div className={"font-gilroy mb-5 mx-5 text-white w-full md:w-2/3"}>
                                The nearest airports are London Heathrow Airport, London City Airport,
                                London Stansted Airport and London Luton Airport.
                            </div>
                        </div>
                    </div>

                <div className={"w-full lg:w-1/2 flex flex-row p-20  bg-app-gray-travel relative"}>
                    <div className={"flex flex-col"}>
                        <div className={"font-gilroy mb-5 mx-5 text-white flex flex-row"}>
                            <img className={"w-20"} src={asset('images/train.png')} />
                            <div className={"self-end text-app-gray-travel-dark text-5xl font-gilroy"}>
                                Train
                            </div>
                        </div>
                        <div className={"font-gilroy mb-5 mx-5 text-app-gray-travel-dark"}>
                            The nearest underground station to Lakeside is Finchley Central, which is situated on the High Barnet
                            branch of the Northern Line, approximately 20 minutes’ ride from central London.
                            From the station it’s a short cab ride or walk to Lakeside.
                        </div>
                    </div>
                    <div className={"text-white font-gilroy -mr-10 -my-6 text-9xl"}
                         style={{
                             writingMode: 'tb-rl',
                             transform: 'rotate(-180deg)'
                         }}
                    >

                </div>
                </div>
            </div>
        );
    }

    renderFootInfo(){
        return (
            <div className={"flex flex-col lg:flex-row"}>
                <div className={"w-full lg:w-1/2 flex flex-row p-10 bg-app-gray-travel-red-bg relative"}>
                        <div className={"flex flex-col"}>
                            <div className={"font-gilroy mb-5 mx-5 text-white flex flex-row"}>
                                <div className={"self-end text-white text-3xl font-gilroy"}>
                                    Foot and bike
                                </div>
                            </div>
                            <div className={"font-gilroy mb-5 mx-5 text-white"}>
                                From Finchley Central Underground Station
                            </div>
                            <div className={"font-gilroy mb-5 mx-5 text-white"}>
                                Starting from the underground station, facing away from Ballards Lane, walk down Station Road.
                                Walk for around eight minutes, then turn left onto Squires Lane. Shortly after,
                                turn left again into Lakeside – the entrance is on your left, just after you cross
                                the small railway bridge. If you prefer to travel by bike, we offer secure, on-site cycle parking.
                            </div>
                        </div>
                    </div>

                <div className={"w-full lg:w-1/2 flex flex-row p-5 bg-app-gray-travel-red-bg relative "}>
                    <div className={"flex flex-col z-20 self-end"}>
                        <div className={"font-gilroy mb-5 mx-5 text-white flex flex-row"}>
                        </div>
                        <div className={"font-gilroy font-bold mb-5 mx-5 text-white w-1/2"}>
                            If you prefer to travel by bike, we offer secure, on-site cycle parking.
                        </div>
                    </div>
                    <div className={"hidden md:block text-app-gray-travel-red font-gilroy -mr-0 -my-6 text-9xl absolute left-0 right-0 flex-col z-10"}
                    >
                        <div className={"flex flex-row gap-0"}>
                            <div className={"w-10/12 text-walk-box px-5 pb-0 mb-0"}>
                                Walk
                            </div>
                            <div className={"w-2/12"}>
                                <img className={"w-64 p-5 text-white"} src={asset('images/pages/travel/person.svg')} />
                            </div>
                        </div>
                        <div className={"text-right text-8xl -mt-12"}>
                            Cycle
                        </div>
                </div>
                </div>
            </div>
        );
    }

}
